import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { PersonaTypes } from '@app/modules/personas/enums/persona-types.enum'
import { TruncationDetectorDirective } from '@app/v2/shared/directives/truncation-detector.directive'
import { NgxTippyModule } from 'ngx-tippy-wrapper'

@Component({
  selector: 'ngx-persona-selection',
  templateUrl: './persona-selection.component.html',
  styleUrls: ['./persona-selection.component.scss'],
  imports: [CommonModule, TruncationDetectorDirective, NgxTippyModule],
  standalone: true
})
export class PersonaSelectionComponent {
  @Output()
  personaSelected = new EventEmitter<string>()

  @Input()
  personas: { slug: string; name: string; type?: PersonaTypes }[]

  @Input()
  selectedPersona: string

  selectPersona(personaSlug: string) {
    this.selectedPersona = personaSlug
    this.personaSelected.next(personaSlug)
  }
}
